import gql from 'graphql-tag'

/**
 * Query
 */
const GET_BY_EMPLOYEE = gql`
    query cessationEmployeesWithPagination ($employee_id: ID!, $page: Int, $perPage: Int) {
        cessationEmployeesWithPagination (employee_id: $employee_id, page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                date
                description
                employee_id
                type
                employee {
                    id
                    name
                    last_name
                    fullName
                }
                reason_id
                reason {
                    id
                    name
                }
            }
        }
    }
`

/**
 * Mutations
 */
 const CREATE_CESSATION = gql`
    mutation createCessationEmployee ($input: CessationEmployeesInput!){
        createCessationEmployee (input: $input) {
            id
            date
            description
            employee_id
            type
            employee {
                id
                name
                last_name
                fullName
            }
            reason_id
            reason {
                id
                name
            }
        }
    }
`
const UPDATE_CESSATION = gql`
    mutation updateCessationEmployee ($id: ID!, $input: CessationEmployeesInput!){
        updateCessationEmployee (id: $id, input: $input) {
            id
            date
            description
            employee_id
            type
            employee {
                id
                name
                last_name
                fullName
            }
            reason_id
            reason {
                id
                name
            }
        }
    }
`

const DELETE_CESSATION = gql`
    mutation deleteCessationEmployee ($id: ID!){
        deleteCessationEmployee (id: $id) {
            id
            date
        }
    }
`
export {
    CREATE_CESSATION,
    GET_BY_EMPLOYEE,
    UPDATE_CESSATION,
    DELETE_CESSATION
}
